import { render, staticRenderFns } from "./PedidoRapartoTableComponent.vue?vue&type=template&id=3730b0b3&"
import script from "./PedidoRapartoTableComponent.vue?vue&type=script&lang=js&"
export * from "./PedidoRapartoTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports